<template lang='pug'>
.articleStory
  ArticleStoryHead(:info="info" :staticData="staticData")
  ArticleStoryBody(:info="info" :staticData="staticData")
  ArticleStoryFoot(:info="info" :staticData="staticData" :followStatus="followStatus")
</template>
<script>
import ArticleStoryHead from '@/components/modules/article_story/article_story_head.vue'
import ArticleStoryBody from '@/components/modules/article_story/article_story_body.vue'
import ArticleStoryFoot from '@/components/modules/article_story/article_story_foot.vue'
import StaticData from '@/assets/data.json'

export default {
  components: {
    ArticleStoryHead,
    ArticleStoryBody,
    ArticleStoryFoot,
    StaticData
  },
  props: {
    info: Object,
    staticData: Object,
    followStatus: Boolean
  }
}
</script>
